import template from './contactCompanyIndividual.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    contact: '<',
    individual: '<',
    individuals: '<',
    countries: '<',
    validationErrors: '<',
    location: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      helperService,
      Contact,
      contactService,
      contactsService,
      searchService,
      PersonalTitle,
      CONTACT,
      uiService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.organizationCountry = [];
      ctrl.availablePersonalTitles = [];
      ctrl.phoneValidationMessage = '';

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.contact = ctrl.contact || {};
        ctrl.individual = ctrl.individual || {};
        ctrl.individuals = ctrl.individuals || [];
        ctrl.countries = ctrl.countries || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.location = ctrl.location || {};
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.index = _.findIndex(ctrl.individuals, (i) => i?.id === ctrl.individual?.id);
      };

      ctrl.updateContact = _.debounce((data) => {
        const individual = data;
        if (!_.isString(individual?.firstName)) {
          individual.firstName = individual?.firstName?.name || '';
        }
        if (ctrl.searchText && _.isString(ctrl.searchText) && !individual?.firstName) {
          individual.firstName = ctrl.searchText;
        }
        if (individual?.firstName && individual?.familyName) {
          contactsService.clearCache();
          let contact = null;

          if (!individual?.idContact) {
            contact = Contact.blank();
            contact = ctrl.fillContactFields(contact, individual);
            contactService.createContact(contact).then((result) => {
              if (result.status) {
                individual.idContact = result.id;
                ctrl.onFinished({ contact: ctrl.contact });
              }
            });
          } else {
            contactService.readContact({ id: individual.idContact }).then((result) => {
              contact = ctrl.fillContactFields(result, individual);
              contactService.updateContact(contact);
              ctrl.onFinished({ contact: ctrl.contact });
            });
          }
        }
      }, 2000);

      ctrl.fillContactFields = (data, individual) => {
        const contact = data;
        contact.id = individual.idContact;
        contact.person.information.title = individual.title;
        contact.person.information.firstName = individual.firstName || ctrl.searchText;
        contact.person.information.familyName = individual.familyName;
        contact.person.contact.primaryCode = individual.phoneCode;
        contact.person.contact.primary = individual.phone;
        contact.person.contact.email = individual.email;
        return contact;
      };

      ctrl.selectedItemChange = (selectedContact) => {
        if (selectedContact && selectedContact.id) {
          contactService.readContact({ id: selectedContact.id }).then((data) => {
            const contact = data;
            if (contact && contact.id) {
              const individualExist = ctrl.contact.company.information.individuals.find(
                (c) => c.idContact === contact.id
              );
              if (!individualExist) {
                ctrl.individual.idContact = contact.id;
                ctrl.individual.title = contact.person.information.title;
                ctrl.individual.firstName = contact.person.information.firstName;
                ctrl.individual.familyName = contact.person.information.familyName;
                ctrl.individual.phoneCode = contact.person.contact.primaryCode;
                ctrl.individual.phone = contact.person.contact.primary;
                ctrl.individual.email = contact.person.contact.email;
                ctrl.updateContact(ctrl.individual);
              } else {
                ctrl.individual.idContact = '';
                ctrl.individual.title = '';
                ctrl.individual.firstName = '';
                ctrl.individual.familyName = '';
                ctrl.individual.primaryCode = '';
                ctrl.individual.primary = '';
                ctrl.individual.email = '';
                uiService.toast({
                  text: { p1: 'WARNING', p2: 'the same contact cannot be', p3: 'added twice' },
                  warn: true
                });
              }
            }
          });
        }
      };

      ctrl.searchContact = (query) => searchService.getContacts({ query, isCompany: false });

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
